module.exports = __webpack_public_path__ + "static/media/Camerupt_gaussian2.d7a08282.png";